/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/

import React, { useState, useEffect } from 'react';
import {
    Grid,
    CardContent,
    Typography,
    FormControl,
    Button,
    Box,
    FormHelperText,
    CircularProgress,

} from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-mui'
import { makeStyles } from 'tss-react/mui';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify'
import * as Yup from 'yup';
import InputAdornment from "@mui/material/InputAdornment";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Loader from '../../../../ui-elements/loader'
import { useNavigate } from 'react-router-dom';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import BackButton from '../../../shared/Buttons/BackButton';
import MainCard from '../../../../ui-elements/cards/MainCard';
import { getUserInfo } from '../../../../store/reducers/user/userAction';
import { patchPassword, patchUserMe } from '../../../../services/user/UserController';
import { useCallback } from 'react';


const Account = ({ ...props }) => {
    const [loading, changeLoading] = useState(true);
    const [edit, toggleEdit] = useState(false);
    const [editPwd, toggleEditPwd] = useState(false);
    const [showPassword, setShowPassword] = useState(false)
    const { classes } = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const user = useSelector(state => state.user.user)

    const fetchUserInfo = useCallback(async () => {
        try {
            await dispatch(getUserInfo()).unwrap()
            changeLoading(false);

        } catch (error) {
            changeLoading(false);

        }

    }, [dispatch]);
    useEffect(() => {
        fetchUserInfo()

    }, [fetchUserInfo]);
    return (
        <Box m={2}>
            <Grid>
                <BackButton pageTitle="Contact Information" />
                <MainCard  >

                    {loading ? <Loader /> :
                        <>
                            {!editPwd && <> {!edit ? (
                                <>
                                    <CardContent>
                                        <Grid container spacing={3}>

                                            <Grid item xs={12} sm={12} md={6} >
                                                <List component="nav" disablePadding>


                                                    <ListItem disableGutters={true}   >

                                                        <Typography variant="h4"><b>Display Name:</b> {user.displayName ? user.displayName : 'N/A'}</Typography>
                                                    </ListItem>

                                                    <ListItem disableGutters={true}   >

                                                        <Typography variant="h4">
                                                            <b>Email : </b> {user.email ? user.email : 'N/A'}
                                                        </Typography>
                                                    </ListItem>


                                                </List>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6} >
                                                <Button variant="contained" color="primary" style={{ marginTop: '20px', marginBottom: '20px' }}
                                                    onClick={() => { toggleEditPwd(false); toggleEdit(true) }}
                                                >
                                                    Edit Contact Information
                                                </Button>
                                                <Button variant="outlined" color="primary" style={{ marginTop: '20px', marginBottom: '20px', marginLeft: '20px' }}
                                                    onClick={() => { toggleEditPwd(true); toggleEdit(false) }}
                                                >
                                                    Edit Password
                                                </Button>
                                                <Button
                                                    style={{ marginTop: '20px', marginLeft: '20px', marginBottom: '20px' }}
                                                    onClick={() => navigate('/dashboard')}
                                                >
                                                    Return
                                                </Button>
                                            </Grid>
                                        </Grid>


                                    </CardContent>

                                </>
                            ) : (
                                !loading &&
                                edit && (
                                    <>
                                        <CardContent>
                                            <Formik
                                                initialValues={{
                                                    displayName: user.displayName ? user.displayName : "",
                                                    email: user.email ? user.email : "",
                                                }}
                                                validationSchema={Yup.object().shape({
                                                    displayName: Yup.string(),
                                                    email: Yup.string().email(),

                                                })}
                                                onSubmit={async (
                                                    values,
                                                    { setSubmitting }
                                                ) => {
                                                    try {
                                                        await patchUserMe(values)
                                                        toast.info('Updating  User Information went successfully');
                                                        await dispatch(getUserInfo()).unwrap();
                                                        toggleEdit(false);
                                                        setSubmitting(false);
                                                    } catch (error) {
                                                        toast.warning("Something went wrong, please try later");
                                                        setSubmitting(false);

                                                    }

                                                }}



                                            >
                                                {({ values, handleBlur, handleChange, touched, errors, setFieldValue
                                                }) => (

                                                    <Form>
                                                        <Grid container spacing={4}>


                                                            <Grid item xs={12} sm={12} md={6} >
                                                                <Grid container spacing={4}>


                                                                    <Grid item xs={12} sm={12} md={6}>
                                                                        <FormControl fullWidth className={classes.formInput}>
                                                                            <Field
                                                                                id="outlined-Username"
                                                                                type="text"
                                                                                value={values.displayName}
                                                                                variant="outlined"
                                                                                name="displayName"
                                                                                label="Display Name"
                                                                                onBlur={handleBlur}
                                                                                onChange={handleChange}
                                                                                fullWidth
                                                                                component={TextField}

                                                                            />
                                                                            {touched.username && errors.username && (
                                                                                <FormHelperText error id="standard-weight-helper-text-asset">
                                                                                    {' '}
                                                                                    {errors.username}{' '}
                                                                                </FormHelperText>
                                                                            )}
                                                                        </FormControl>

                                                                    </Grid>


                                                                    <Grid item xs={12} sm={12} md={6}>
                                                                        <FormControl fullWidth className={classes.formInput}>
                                                                            <Field
                                                                                id="outlined-email"

                                                                                type="text"

                                                                                value={values.email}
                                                                                variant="outlined"
                                                                                name="email"
                                                                                label="Email"
                                                                                onBlur={handleBlur}
                                                                                onChange={handleChange}
                                                                                fullWidth
                                                                                component={TextField}
                                                                                disabled={true}  
                                                                            />
                                                                            {touched.email && errors.email && (
                                                                                <FormHelperText error id="standard-weight-helper-text-asset">
                                                                                    {' '}
                                                                                    {errors.email}{' '}
                                                                                </FormHelperText>
                                                                            )}
                                                                        </FormControl>

                                                                    </Grid>
                                                                </Grid>


                                                            </Grid>

                                                        </Grid>
                                                        <Button type="submit"
                                                            variant="contained"
                                                            color="primary"
                                                            style={{ marginBottom: '20px' }} >
                                                            Save
                                                        </Button>
                                                        <Button style={{ marginLeft: '20px', marginBottom: '20px' }} onClick={() => toggleEdit(false)}>
                                                            Cancel
                                                        </Button>

                                                    </Form>
                                                )}
                                            </Formik>

                                        </CardContent>
                                    </>
                                )
                            )}
                            </>}
                            {editPwd &&
                                <>
                                    <Formik
                                        initialValues={{
                                            password: '',
                                            confirmPassword: ''
                                        }}
                                        validationSchema={Yup.object().shape({
                                            password: Yup.string().min(8).max(40).required(),
                                            confirmPassword: Yup.string().min(8).max(40).oneOf([Yup.ref('password'), null], 'Passwords must match').required('password is required'),

                                        })}
                                        onSubmit={async (
                                            { password },
                                            { setSubmitting }
                                        ) => {
                                            try {
                                                await patchPassword({ password }).unwrap()
                                                setSubmitting(false);
                                                toggleEditPwd(false);
                                                toggleEdit(false)
                                                toast.info('Change password went successful')
                                            } catch (error) {
                                                setSubmitting(false);

                                            }

                                        }}
                                    >
                                        {({ isSubmitting, values, errors, touched, handleBlur, handleChange }) => (
                                            <Form>


                                                <Grid container spacing={4} style={{ padding: '50px' }}>

                                                    <Grid item xs={12} sm={4} md={4} />


                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <Typography variant="h3" color='primary' align="center">Change My Password</Typography>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={12} md={12}>
                                                                <FormControl fullWidth error={Boolean(touched.password && errors.password)}>

                                                                    <Field
                                                                        name="password"
                                                                        label="New Password"
                                                                        type={showPassword ? "text" : 'password'}
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        margin="normal"
                                                                        variant="outlined"

                                                                        value={values.password}
                                                                        component={TextField}
                                                                        InputProps={{

                                                                            endAdornment: (
                                                                                <InputAdornment position="end">
                                                                                    <IconButton
                                                                                        onClick={() => setShowPassword(showPassword => !showPassword)}
                                                                                    >
                                                                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                                                                    </IconButton>
                                                                                </InputAdornment>
                                                                            )
                                                                        }}
                                                                    />

                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={12}>
                                                                <FormControl fullWidth error={Boolean(touched.confirmPassword && errors.confirmPassword)}>

                                                                    <Field
                                                                        value={values.confirmPassword}
                                                                        component={TextField}

                                                                        name="confirmPassword"
                                                                        label="Confirm New Password"
                                                                        type={showPassword ? "text" : 'password'}
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        margin="normal"
                                                                        variant="outlined"

                                                                        InputProps={{

                                                                            endAdornment: (
                                                                                <InputAdornment position="end">
                                                                                    <IconButton
                                                                                        onClick={() => setShowPassword(showPassword => !showPassword)}
                                                                                    >
                                                                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                                                                    </IconButton>
                                                                                </InputAdornment>
                                                                            )
                                                                        }}
                                                                    />

                                                                </FormControl>
                                                            </Grid>


                                                        </Grid>




                                                        <Grid container>
                                                            <Grid item xs={12} sm={12} md={12}>

                                                                <Button variant="contained" color="primary" type="submit" >
                                                                    {isSubmitting && (
                                                                        <CircularProgress size={24} color="warning" />
                                                                    )}   Save
                                                                </Button>
                                                                <Button
                                                                    variant="outlined"
                                                                    style={{ marginLeft: '10px' }}
                                                                    onClick={() => {
                                                                        toggleEditPwd(false);
                                                                    }}
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                            </Form>
                                        )}
                                    </Formik>
                                </>
                            }
                        </>
                    }
                </MainCard>
            </Grid>
        </Box>

    )

}
const useStyles = makeStyles({ "name": { Account } })(theme => ({
    formInput: {
        ...theme.typography.customInput,
        marginBottom: '10px !important'
    },
    avatar: {
        margin: 'auto',

        width: '100px!important',
        height: '100px!important'

    },
    dialogHeader: {
        paddingBottom: '50px!important'
    }

}));


export default Account
